import { NodeInterface, QuestType } from "@swivl-mono/types";
import { QuestsModel } from "../../../../Models/Quests/Quests.Model";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import DelayComponent from "../SidePanel/Inspector/components/DelayComponent";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import { QuestsDropdown } from "../../../../Components/Dropdowns/QuestsDropdown/QuestsDropdown";
import { RandomId } from "@swivl-mono/helpers";

const Quest = {
  Type: "quest",
  Empty: function () {
    return {
      "id": RandomId(6),
      "type": Quest.Type,
      "delay": 0,
      "showTyping": false,
      "questSlug": "",
      "name": "",
      "onCompleteGoto": null,
      "isFinishHookedUp": false,
    }
  },

  PlumbData: function (node: NodeInterface) {
    const gotoQuest = QuestsModel.state!.quests![node.questSlug]

    const name = (gotoQuest && gotoQuest.name) ? gotoQuest.name : "";

    return TabNodeLayoutData({
      node: node,
      label: "Quest",
      title: name,
      titleHeight: name?.length > 14 ? 65 : 20,
      baseWidth: 150,
      tabs: (gotoQuest && gotoQuest.type === QuestType.MATRIX) ? [] : [{ id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto, }]
    });

  },
  InspectorPanel: function QuestInspectorPanel(props: any) {
    const journeys = QuestsModel.useState(s => s.journeys)
    return <Quest.InternalInspectorPanel {...props} journeys={journeys} />
  },

  InternalInspectorPanel: class QuestInspectorPanel extends NodePanel {
    render() {
      var questOptions;
      if ((this.props as any).journeys) {
        questOptions = [];

        for (var i = 0; i < (this.props as any).journeys.length; i++) {
          questOptions.push({ isHeading: true, name: (this.props as any).journeys[i].name })
          for (var q = 0; q < (this.props as any).journeys[i].quests.length; q++) {
            questOptions.push({ id: (this.props as any).journeys[i].quests[q].id, value: (this.props as any).journeys[i].quests[q].id, name: (this.props as any).journeys[i].quests[q].get("name") })
          }
        }
      }

      return (
        <div>
          <div className="panel quest_panel">
            <InspectorNodeHeader title="Quest" id={this.props.node.id} />
            <DelayComponent node={this.props.node} onChange={this.onChange} />
            Goto Quest:
            <QuestsDropdown value={this.props.node.questSlug} name="questSlug" onChange={this.onChange} />
            <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
          </div>
        </div>
      );
    }
  }
}

export default Quest;
